import { EngineRenderers } from '@websky/core/src/renderProps';

import Location from './components/Location/Location';
import FlightInfoSegment from './components/FlightInfoSegment/FlightInfoSegment';
import Cell from './components/CompareFares/Cell';
import SegmentPlaneInfo from './components/SegmentPlaneInfo/SegmentPlaneInfo';
import CompareFaresSlider from './components/CompareFaresSlider/CompareFaresSlider';
import PassengersCloseBtn from './components/SearchForm/Passengers/CloseBtn/CloseBtn';
import DatepickerValue from './components/DatepickerValue/DatepickerValue';
import SelectedFlight from './components/Checkout/SelectedFlight/SelectedFlight';
import CurrencyWarning from './components/Checkout/CurrencyWarning/CurrencyWarning';
import PassengerToolbarAdditional from './components/Checkout/PassengerToolbar/PassengerToolbarAdditional';
import SpecialEqupmentBaggageCard from './components/Baggage/SpecialEqupment/BaggageCard';
import CheckinNotification from './theme/components/Notification/CheckinNotification';
import DescriptionRender from './theme/components/FareConditions/DescriptionRender';
import { specialEquipmentItemsSort } from './components/HeaderEquipmentIcon/icons';
import CheckoutFormPassenger from './components/CheckoutFormPassenger/CheckoutFormPassenger';
import CheckoutForm from './components/CheckoutForm/CheckoutForm';
import BaggageBody from './components/Baggage/UpgradeBaggageDialog/BaggageBody/BaggageBody';
import PassengerFormField from './components/CheckoutFormPassenger/PassengerFormField';
import CheckoutContacts from './components/CheckoutFormPassenger/CheckoutContacts';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService';
import SearchFormBeforeAdornment from './components/SearchForm/BeforeAdornment/BeforeAdornment';
import PassengersNotifications from './components/Checkout/PassengersNotifications/PassengersNotifications';
import CompletedCheckinAdditionalBanner from './components/Checkin/CompletedCheckinAdditionalBanner/CompletedCheckinAdditionalBanner';
import { redwingsPaymentIcons } from './components/icons';
import PriceParts from './components/PaymentForm/PriceParts/PriceParts';
import SeatMapServiceContent from './components/SeatMapServiceContent/SeatMapServiceContent';
import Business from './components/CheckoutAdditionalService/Business/Business';
import WarningDescription from './components/FareLock/WarningDescription';
import InsuranceCardOptions from './components/InsurancePopup/InsuranceCard/InsuranceCardOptions';
import OrderInsuranceBlockSlotUpsale from '../../core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import { FareFeaturePaymentType } from '@websky/graphql';
import { InsuranceProductView as InsuranceProductViewV2 } from '@websky/core/src/InsurancePage/components/InsuranceProduct/InsuranceProductViewV2/InsuranceProductView';

export default {
	CheckinNotification: CheckinNotification,
	DescriptionRenderers: DescriptionRender,
	FlightInfoLocation: Location,
	renderFlightInfoSegment: FlightInfoSegment,
	renderWarningDescription: WarningDescription,
	CheckoutSelectedFlight: SelectedFlight,
	CheckoutCurrencyWarning: CurrencyWarning,
	renderSegmentPlaneInfo: SegmentPlaneInfo,
	Cell,
	renderCompareFaresSlider: CompareFaresSlider,
	SearchFormPassengersCloseBtn: PassengersCloseBtn,
	renderDatepickerValue: DatepickerValue,
	renderBaggageBody: BaggageBody,
	CheckoutFormPassenger,
	CheckoutForm,
	specialEquipmentItemsSort: specialEquipmentItemsSort,
	PassengerFormField,
	CheckoutContacts,
	CheckoutAdditionalService: {
		CheckoutAdditionalService
	},
	SearchFormRenderers: {
		BeforeAdornment: SearchFormBeforeAdornment
	},
	CheckoutPassengersNotifications: PassengersNotifications,
	Paid: () => redwingsPaymentIcons?.[FareFeaturePaymentType.Pay],
	NotIncluded: () => redwingsPaymentIcons?.[FareFeaturePaymentType.NotAvailable],
	Included: () => redwingsPaymentIcons?.[FareFeaturePaymentType.Free],
	renderPassengersToolbarAdditional: PassengerToolbarAdditional,
	CheckinOrderAdditionalBanner: CompletedCheckinAdditionalBanner,
	PriceParts,
	SeatMapServiceContent,
	CheckoutBusiness: Business,
	renderInsuranceCardOptions: InsuranceCardOptions,
	CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
	InsuranceProductView: InsuranceProductViewV2
} as EngineRenderers;
